import { render, staticRenderFns } from "./scheduleDetail_matchPanel.vue?vue&type=template&id=6023e9ba&scoped=true"
import script from "./scheduleDetail_matchPanel.vue?vue&type=script&lang=js"
export * from "./scheduleDetail_matchPanel.vue?vue&type=script&lang=js"
import style0 from "./scheduleDetail_matchPanel.vue?vue&type=style&index=0&id=6023e9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023e9ba",
  null
  
)

export default component.exports